import React from "react";
import { Box, TextField, Grid, Typography, Autocomplete } from "@common-ui/ui";
const Heading = () => {
  return (
    <>
      <Grid item md={4} xs={12}>
        <Typography variant="h4">Catalog Item</Typography>
        <Autocomplete
          id="country-select"
          // disablePortal
          // disabled={!customers?.length}
          ListboxProps={{ style: { maxHeight: "200px" } }}
          options={[
            { name: "Test Catalog Item 1" },
            { name: "Test Catalog Item 2" },
          ]}
          autoHighlight
          size="small"
          getOptionLabel={(option) => option?.name}
          margin="normal"
          name="country"
          limitTags={4}
          fullWidth
          renderOption={(props, option) => (
            <Box
              component="li"
              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
              {...props}
            >
              {option?.name}
            </Box>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="Select"
              margin="normal"
              sx={{ mt: 1 }}
              inputProps={{
                ...params.inputProps,
                autoComplete: "off", // disable autocomplete and autofill
              }}
            />
          )}
        />
      </Grid>
      <Grid item md={4} xs={12}>
        <Typography variant="h4">Client</Typography>
        <Autocomplete
          id="country-select"
          // disablePortal
          // disabled={!customers?.length}
          ListboxProps={{ style: { maxHeight: "200px" } }}
          options={[{ name: "Test Client 1" }, { name: "Test Client 2" }]}
          autoHighlight
          size="small"
          getOptionLabel={(option) => option?.name}
          margin="normal"
          name="country"
          limitTags={4}
          fullWidth
          renderOption={(props, option) => (
            <Box
              component="li"
              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
              {...props}
            >
              {option?.name}
            </Box>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="Select"
              margin="normal"
              sx={{ mt: 1 }}
              inputProps={{
                ...params.inputProps,
                autoComplete: "off", // disable autocomplete and autofill
              }}
            />
          )}
        />
      </Grid>
      <Grid item md={4} xs={12}>
        <Typography variant="h4">Location</Typography>
        <Autocomplete
          id="country-select"
          // disablePortal
          // disabled={!customers?.length}
          ListboxProps={{ style: { maxHeight: "200px" } }}
          options={[{ name: "Test Location 1" }, { name: "Test Location 2" }]}
          autoHighlight
          size="small"
          getOptionLabel={(option) => option?.name}
          margin="normal"
          name="country"
          limitTags={4}
          fullWidth
          renderOption={(props, option) => (
            <Box
              component="li"
              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
              {...props}
            >
              {option?.name}
            </Box>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="Select"
              margin="normal"
              sx={{ mt: 1 }}
              inputProps={{
                ...params.inputProps,
                autoComplete: "off", // disable autocomplete and autofill
              }}
            />
          )}
        />
      </Grid>
    </>
  );
};

export default React.memo(Heading);
